import { render } from "./LeaveSettingLayout.vue?vue&type=template&id=1e48469e"
import script from "./LeaveSettingLayout.vue?vue&type=script&lang=js"
export * from "./LeaveSettingLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__